(function () {
  if (window.__beToggleBound__) return;
  window.__beToggleBound__ = true;

  const root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    "/";

  const buildSectionsParam = () => {
    const set = new Set();
    document.querySelectorAll("[data-section-id]").forEach((el) =>
      set.add(el.getAttribute("data-section-id"))
    );
    document
      .querySelectorAll("cart-items-component,[data-cart-section-id]")
      .forEach((el) => {
        if (el.dataset?.sectionId) set.add(el.dataset.sectionId);
        if (el.dataset?.cartSectionId) set.add(el.dataset.cartSectionId);
      });

    if (set.size === 0) {
      ["cart-items", "cart-icon-bubble", "cart-live-region-text", "cart-footer"].forEach((id) =>
        set.add(id)
      );
    }

    return Array.from(set).filter(Boolean).join(",");
  };

  const sectionsUrl = () =>
    window.location.pathname.startsWith("/")
      ? window.location.pathname
      : "/" + window.location.pathname;

  const pending = new Set();

  const applySections = (sectionsObj) => {
    if (!sectionsObj || typeof sectionsObj !== "object") return;

    for (const [sectionId, html] of Object.entries(sectionsObj)) {
      if (!html) continue;

      const wrapperId = "shopify-section-" + sectionId;
      const container = document.getElementById(wrapperId);
      if (!container) continue;

      const range = document.createRange();
      const fragment = range.createContextualFragment(String(html));
      const newEl = fragment.querySelector("#" + CSS.escape(wrapperId));

      if (newEl) container.replaceWith(newEl);
    }
  };

  document.addEventListener("change", async (evt) => {
    const el = evt.target;
    if (!el || !el.matches('[id^="productCheckbox-"]')) return;

    const variantIdStr = el.id.replace("productCheckbox-", "").trim();
    if (!variantIdStr || pending.has(variantIdStr)) return;

    const variantIdNum = parseInt(variantIdStr, 10);
    const isAdding = el.checked;
    const sections = buildSectionsParam();
    const sections_url = sectionsUrl();

    pending.add(variantIdStr);
    el.disabled = true;

    try {
      if (isAdding) {
        const body = {
          items: [{ id: variantIdNum, quantity: 1 }],
          sections,
          sections_url,
        };

        const res = await fetch(root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(body),
        });

        if (!res.ok) throw new Error("Cart add failed");

        const data = await res.json();
        applySections(data.sections);

        ["cart:update", "cart:updated", "cart:refresh"].forEach((evtName) =>
          document.dispatchEvent(
            new CustomEvent(evtName, {
              detail: { data: { sections: data.sections } },
              bubbles: true,
            })
          )
        );
      } else {
        const cart = await fetch(root + "cart.js?t=" + Date.now(), {
          headers: { Accept: "application/json" },
        }).then((r) => r.json());

        const item = cart.items.find((i) => Number(i.variant_id) === variantIdNum);
        if (!item) return;

        const body = { id: item.key, quantity: 0, sections, sections_url };

        const res = await fetch(root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(body),
        });

        if (!res.ok) throw new Error("Cart change failed");

        const data = await res.json();
        applySections(data.sections);

        ["cart:update", "cart:updated", "cart:refresh"].forEach((evtName) =>
          document.dispatchEvent(
            new CustomEvent(evtName, {
              detail: { data: { sections: data.sections } },
              bubbles: true,
            })
          )
        );
      }
    } catch (err) {
      console.error("Erreur toggle upsell:", err);
      el.checked = !isAdding;
    } finally {
      pending.delete(variantIdStr);
      el.disabled = false;
    }
  });
})();